/**
 * Auth Module
 *
 * Provides cookie-based authentication storage for Saleor Auth SDK,
 * enabling SSR access to authentication state.
 *
 * Part of BEC-20884: Cookie persistence for Saleor Auth token
 */

export { getRequestAuthToken } from './getRequestAuthToken';
export {
  fetchStorefrontBffWithAuth,
  getClientAccessToken,
} from './fetchStorefrontBffWithAuth';

export {
  // Storage classes
  CookieRefreshTokenStorage,
  CookieAccessTokenStorage,
  // Storage getters
  getRefreshTokenStorage,
  getAccessTokenStorage,
  // Cookie names (matching @saleor/auth-sdk internal keys)
  AUTH_REFRESH_TOKEN_COOKIE,
  AUTH_ACCESS_TOKEN_COOKIE,
  AUTH_STATE_COOKIE,
  // Server-side utilities
  parseRequestCookies,
  getServerSideRefreshToken,
  getServerSideAccessToken,
  isAuthenticatedServerSide,
  getServerSideUserId,
  decodeTokenPayload,
  // Types
  type StorageRepository,
} from './cookieStorage';
